import type { JSX } from 'react';
import type { Me } from '../auth/use-me';
import { ActivityPage } from '../activity/activity-page';
import { HealthPage } from '../health/health-page';
import { OverviewPage } from '../overview/overview-page';
import { AgentPage } from '../agent/agent-page';
import { SourcesPage } from '../sources/sources-page';
import { UsersPage } from '../users/users-page';
import { ChatPage } from '../chat/chat-page';
import { SchedulesPage } from '../schedules/schedules-page';
import type { Route } from './routes';

/** One screen per route. Each page owns its data; the shell only picks which. */
export function Screen({ route, me }: { route: Route; me: Me }): JSX.Element {
  switch (route.page) {
    case 'overview':
      return <OverviewPage me={me} />;
    case 'chat':
      return <ChatPage route={route} me={me} />;
    case 'sources':
      return <SourcesPage route={route} me={me} />;
    case 'users':
      return <UsersPage route={route} me={me} />;
    case 'activity':
      return <ActivityPage route={route} />;
    case 'agent':
      return <AgentPage me={me} />;
    case 'schedules':
      return <SchedulesPage route={route} me={me} />;
    case 'health':
      return <HealthPage />;
  }
}
